/*
 * Public API Surface of core
 */

export * from './lib/ngx-electron.service';
export * from './lib/models';
export * from './lib/auto-updater-proxy';
export * from './lib/directives/ngx-electron-content-menus.directive';
export * from './lib/directives/ngx-electron-drag.directive';
export {RendererModule as NgxElectronRendererModule} from './lib/renderer.module';
